import clsx from 'clsx';

import type { Adaptive } from '../types/Adaptive';
import type { JustifyItems } from '../types/JustifyItems';

export function composeJustifyItemsClasses(justify: Adaptive<JustifyItems>): string {
    if (typeof justify === 'object') {
        return clsx(
            justify.base && `justify-${justify.base}`,
            justify.sm && `sm:justify-${justify.sm}`,
            justify.md && `md:justify-${justify.md}`,
            justify.lg && `lg:justify-${justify.lg}`,
            justify.xl && `xl:justify-${justify.xl}`,
            justify['2xl'] && `2xl:justify-${justify['2xl']}`
        );
    }

    return `justify-${justify}`;
}
